import { on } from "svelte/events";
import { findScrollingElement } from "../../utils/findContainingElement";

export const attachPositioningEventListeners = (
  containingElement: HTMLElement | null,
  onPositionChange: () => void,
): (() => void) => {
  if (!containingElement) return () => {};
  /*                                                                      */
  const scrollWindowRemove = on(window, "scroll", onPositionChange, { passive: true });
  const resizeWindowRemove = on(window, "resize", onPositionChange, { passive: true });
  const removeWindowListeners = (): void => {
    scrollWindowRemove();
    resizeWindowRemove();
  };
  /*                                       */
  const clippingElement = findScrollingElement(containingElement);
  if (clippingElement) {
    const scrollClippingRemove = on(clippingElement, "scroll", onPositionChange, { passive: true });
    const resizeObserver = new ResizeObserver(onPositionChange);
    resizeObserver.observe(clippingElement);

    return () => {
      scrollClippingRemove();
      resizeObserver.disconnect();
      removeWindowListeners();
    };
  }
  return removeWindowListeners;
};
